import { render, staticRenderFns } from "./LogoutOtherBrowserSessionsFormV.vue?vue&type=template&id=7f84577c&"
import script from "./LogoutOtherBrowserSessionsFormV.vue?vue&type=script&lang=js&"
export * from "./LogoutOtherBrowserSessionsFormV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports